import React from 'react';

import {Text} from '@albert-io/atomic';
import LevelBadge from 'assets/images/adaptive/LevelBadge';

const BADGE_LEVELS: {levelNum: 1 | 2 | 3}[] = [{levelNum: 3}, {levelNum: 2}, {levelNum: 1}];

interface BadgeCountProps {
  levelNum: 1 | 2 | 3;
  count: number;
}

function BadgeCount({levelNum, count}: BadgeCountProps) {
  const isEmpty = count === 0;
  return (
    <div className='flex items-center gap-x0-half rounded-x1 border border-solid border-border-subtle px-x1 py-x0-half'>
      <LevelBadge levelNum={levelNum} width={32} height={32} empty={isEmpty} />
      <Text>{count}</Text>
    </div>
  );
}

export function BadgesAchieved() {
  return (
    <div className='flex items-center gap-x1'>
      {BADGE_LEVELS.map(({levelNum}) => (
        <BadgeCount key={levelNum} levelNum={levelNum} count={0} />
      ))}
    </div>
  );
}
